var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Col } from "react-bootstrap";
import Button from "@irati/ui/src/Button";
import ImageUploader from "@irati/ui/src/ImageUploader";
import { Input } from "@irati/ui/src/FormItem";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { homepageTracking } from "@irati-tracking/platform";
import TileShapes from "../enums/TileShapes";
import { ButtonsWrapper, LeftButton, StyledCheckbox, ErrorMessage } from "../styled/editImage";
import ShapePicker from "./ShapePicker";
import ImagePreview from "./ImagePreview";
import { isValidURL, getImageSize } from "../helpers";
var EditImage = /** @class */ (function (_super) {
    __extends(EditImage, _super);
    function EditImage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            shape: TileShapes.square1x,
            image: null,
            link: null,
            header: null,
            body: null,
            uploadRequired: false,
            openLinkInNewTab: false,
            errorMessages: []
        };
        _this.componentDidMount = function () {
            var _a = _this.props, editingTile = _a.editingTile, withText = _a.withText;
            var image = editingTile.image, link = editingTile.link, header = editingTile.header, body = editingTile.body, openLinkInNewTab = editingTile.openLinkInNewTab;
            var state = {};
            if (editingTile) {
                state.image = image;
                state.link = link;
                state.header = header;
                state.body = body;
                state.openLinkInNewTab = openLinkInNewTab || false;
            }
            if (withText) {
                state.shape = TileShapes.square2x;
            }
            _this.setState(state);
        };
        _this.tileValidation = function (withText) {
            var _a = _this.state, image = _a.image, body = _a.body, link = _a.link;
            var formatMessage = _this.props.formatMessage;
            var validation = true;
            var errorMessages = [];
            if (!image) {
                validation = false;
                var message = "home.customisation.editPanel.error.noImage";
                errorMessages.push(message);
                homepageTracking.editError(formatMessage({ id: message }));
            }
            if (withText && !body) {
                validation = false;
                var message = "home.customisation.editPanel.error.noBody";
                errorMessages.push(message);
                homepageTracking.editError(formatMessage({ id: message }));
            }
            if (link && !isValidURL(link)) {
                validation = false;
                var message = "home.customisation.editPanel.error.invalidURL";
                errorMessages.push(message);
                homepageTracking.editError(formatMessage({ id: message }));
            }
            _this.setState({ errorMessages: errorMessages });
            return validation;
        };
        _this.handleShape = function (selectedShape) {
            _this.setState({ shape: selectedShape });
        };
        _this.handleSave = function (withText) {
            var _a = _this.props, addTileToGrid = _a.addTileToGrid, editingTile = _a.editingTile;
            var _b = _this.state, shape = _b.shape, image = _b.image, link = _b.link, header = _b.header, body = _b.body, openLinkInNewTab = _b.openLinkInNewTab;
            var widgetObject = {
                image: image,
                link: link,
                header: header,
                body: body,
                openLinkInNewTab: openLinkInNewTab
            };
            if (!_this.tileValidation(withText, image, body)) {
                return null;
            }
            addTileToGrid(Object.assign(editingTile, widgetObject), shape);
        };
        _this.handleDeleteImage = function () {
            _this.setState({
                image: null,
                uploadRequired: true
            });
        };
        _this.handleOpenLinkInNewTab = function () {
            _this.setState(function (prevState) { return ({ openLinkInNewTab: !prevState.openLinkInNewTab }); });
        };
        _this.handleAddErrorMessages = function (errorMessages) {
            _this.setState({ errorMessages: errorMessages });
        };
        return _this;
    }
    EditImage.prototype.render = function () {
        var _this = this;
        var _a = this.props, cancelEdit = _a.cancelEdit, withText = _a.withText, editingTile = _a.editingTile, hideShapeSelector = _a.hideShapeSelector, formatMessage = _a.formatMessage;
        var _b = this.state, image = _b.image, shape = _b.shape, link = _b.link, header = _b.header, body = _b.body, uploadRequired = _b.uploadRequired, openLinkInNewTab = _b.openLinkInNewTab, errorMessages = _b.errorMessages;
        var widgetImage = image || editingTile && editingTile.image;
        var imageDimensions = getImageSize(shape);
        return (React.createElement(React.Fragment, null,
            !hideShapeSelector &&
                React.createElement(ShapePicker, { onChange: this.handleShape, selected: shape, withText: withText }),
            React.createElement(Col, { xs: 12 }, widgetImage && !uploadRequired
                ? React.createElement(ImagePreview, { image: widgetImage, handleDeleteImage: this.handleDeleteImage })
                : React.createElement(ImageUploader, { hideHint: true, dropZoneText: formatMessage({ id: "home.customisation.fields.image.uploader.text" }, { dimensions: imageDimensions }), onUploadSuccess: function (value) { return _this.setState({ image: value, uploadRequired: false }); } })),
            React.createElement(Input, { name: "link", type: "text", placeholder: "home.customisation.fields.link.placeholder", value: link, onChange: function (value) { return _this.setState({ link: value }); }, label: "home.customisation.fields.link.label" }),
            withText &&
                React.createElement(React.Fragment, null,
                    React.createElement(Input, { name: "header", type: "text", placeholder: "home.customisation.fields.header.placeholder", value: header, onChange: function (value) { return _this.setState({ header: value }); }, label: "home.customisation.fields.header.label" }),
                    React.createElement(Input, { name: "body", type: "text", placeholder: "home.customisation.fields.text.placeholder", value: body, onChange: function (value) { return _this.setState({ body: value }); }, label: "home.customisation.fields.text.label" })),
            link &&
                React.createElement(StyledCheckbox, { name: "template_toggle", checked: openLinkInNewTab, onChange: this.handleOpenLinkInNewTab },
                    React.createElement(FormattedMessage, { id: "home.customisation.editPanel.link.openLinkInNewTab" })),
            React.createElement(ButtonsWrapper, { xs: 12 },
                errorMessages.map(function (message, i) {
                    return React.createElement(ErrorMessage, { key: i },
                        React.createElement(FormattedMessage, { id: message }));
                }),
                React.createElement(LeftButton, { onClick: cancelEdit },
                    React.createElement(FormattedMessage, { id: "home.customisation.editPanel.cancel.label" })),
                React.createElement(Button, { onClick: function () { return _this.handleSave(withText); } },
                    React.createElement(FormattedMessage, { id: "home.customisation.editPanel.done.label" })))));
    };
    return EditImage;
}(PureComponent));
export default injectIntl(EditImage);
